import React from 'react'
import { Grid } from '@mui/material'
import ContactSystemAdmin from '../pages/ContactSystemAdmin'

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  componentDidCatch (error, errorInfo) {
    console.log('Error: ', error, '\n', 'Error Info: ', errorInfo)
  }

  render () {
    const { hasError } = this.state
    const { children } = this.props
    if (hasError) {
      return <Grid container>
          <ContactSystemAdmin type="server_error" />
      </Grid>
    }
    return children
  }
}
